import useResponsive from "helpers/useResponsive";
import PerformanceV2 from "./PerformanceV2";
import PerformanceMobile from "./PerformanceMobile";

export default function () {
  const { isTablet } = useResponsive();
  if (isTablet) return <PerformanceMobile />;
  return <PerformanceV2 />;
}
